import { clamp } from "lodash-es";

import { maxZoom, minZoom } from "@/model/Settings";
import type { ViewportCoordinate } from "@/model/coordinates";
import { useModalStore } from "@/store/modal";
import { useSelectionStore } from "@/store/selection";
import { TargetScroller, useZoomStore } from "@/store/zoom";

import { executeAfterDragScroll } from "./useDragScroll";

let zoomEnd = 0;

export function processZoom(
  center: ViewportCoordinate,
  factor: number,
  mode: "absolute" | "relative",
) {
  // Disable zoom when a modal is open
  if (useModalStore().isModalOpen()) return;
  if (useSelectionStore().isSelectingWithRect) return;

  const base = mode === "relative" ? useZoomStore().dynamicFactor : useZoomStore().factor;
  const newFactor = clamp(base * factor, minZoom, maxZoom);
  if (useZoomStore().dynamicFactor !== newFactor) {
    useZoomStore().setDynamicFactor(newFactor);
    window.clearTimeout(zoomEnd);
    zoomEnd = window.setTimeout(emitZoom, 400);
    if (!useZoomStore().zooming) {
      emitZoom(center);
    }
  }
}

function emitZoom(center?: ViewportCoordinate) {
  if (center) {
    useZoomStore().startZoom(new TargetScroller(center));
  } else {
    executeAfterDragScroll(useZoomStore().endZoom);
  }
}
